import movementTypes from 'modules/transactions/constants/movementTypes';
import { createMovement } from 'modules/transactions/utils/createMovement';
import { Movement, Range } from 'types';

type GetMovementsProps = {
  rangesToAddToSeller: Range[];
  rangesToRemoveFromSeller: Range[];
  rangesToAddToBuyer: Range[];
  partnerSellerId: string;
  partnerBuyerId: string;
  holdingClassId: string;
};

export const getMovements = ({
  rangesToAddToBuyer,
  rangesToAddToSeller,
  rangesToRemoveFromSeller,
  partnerSellerId,
  partnerBuyerId,
  holdingClassId,
}: GetMovementsProps): Movement[] => {
  const sellerRangesToRemove = rangesToRemoveFromSeller.map(
    (range: Range) =>
      createMovement({
        range: {
          ...range,
          partner: partnerSellerId,
          shareClass: holdingClassId,
        },
        movementType: movementTypes.DECREMENT,
      }) as Movement
  );

  const sellerRangesToAddMovements: Movement[] = rangesToAddToSeller.map(
    (range: Range) =>
      createMovement({
        range: {
          ...range,
          partner: partnerSellerId,
          shareClass: holdingClassId,
        },
        movementType: movementTypes.INCREMENT,
      }) as Movement
  );

  const buyerRangesToAddMovements: Movement[] = rangesToAddToBuyer.map(
    (range: Range) =>
      createMovement({
        range: {
          ...range,
          partner: partnerBuyerId,
          shareClass: holdingClassId,
        },
        movementType: movementTypes.INCREMENT,
      }) as Movement
  );

  const movements: Movement[] = [
    ...(sellerRangesToRemove || []),
    ...(sellerRangesToAddMovements || []),
    ...(buyerRangesToAddMovements || []),
  ];

  return movements;
};
